import { render, staticRenderFns } from "./AnonymousMenuItem.vue?vue&type=template&id=556257d4"
import script from "./AnonymousMenuItem.vue?vue&type=script&lang=js"
export * from "./AnonymousMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports